// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCartState, getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";

export const getErpSystemStatus = (state: ApplicationState, cartId?: string) => {
    const cartState = cartId ? getCartState(state, cartId) : getCurrentCartState(state);
    const cart = cartState.value;
    const { erpSystemIsDown, erpSystemIsDownMessage } = cart?.properties || {
        erpSystemIsDown: "false",
        erpSystemIsDownMessage: "",
    };

    return { erpSystemIsDown: erpSystemIsDown?.toLowerCase() === "true", erpSystemIsDownMessage };
};
